import { render, staticRenderFns } from "./InformasiLainnyaDetail-Mobile.vue?vue&type=template&id=16f05a10&scoped=true"
import script from "./InformasiLainnyaDetail-Mobile.vue?vue&type=script&lang=js"
export * from "./InformasiLainnyaDetail-Mobile.vue?vue&type=script&lang=js"
import style0 from "./InformasiLainnyaDetail-Mobile.vue?vue&type=style&index=0&id=16f05a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f05a10",
  null
  
)

export default component.exports